import appSettings from '@/plugins/appSettings'
import aesjs from 'aes-js'

const crypt = (textKey) => {
  // Convert Key to bytes
  const encKey = aesjs.utils.utf8.toBytes(appSettings.authConfigurations.uniqueIdentifier)
  // Convert text to bytes
  const textBytes = aesjs.utils.utf8.toBytes(textKey)
  // AES encyption process
  const aesCtr = new aesjs.ModeOfOperation.ctr(encKey)
  const encryptedBytes = aesCtr.encrypt(textBytes)
  // Convert value to hex
  const encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes)
  return encryptedHex
}
export default crypt
